import { forwardRef } from "react";
import { SvgIcon, type SvgIconProps } from "@mui/material";

const FileClock = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon viewBox="0 0 32 32" ref={ref} {...props}>
      <path d="M6.4 0h12.8l9.6 9.6v19.2c0 1.76-1.44 3.2-3.2 3.2H6.384C4.624 32 3.2 30.56 3.2 28.8l.016-25.6C3.216 1.44 4.64 0 6.4 0zm11.2 2.4v8.8h8.8l-8.8-8.8zM16 15.111c-3.422 0-6.222 2.8-6.222 6.222s2.8 6.222 6.222 6.222 6.222-2.8 6.222-6.222c0-3.422-2.8-6.222-6.222-6.222zm-.622 6.845 3.236 1.991.498-.809-2.8-1.68v-3.236h-.933v3.733z"/>
    </SvgIcon>
  );
});

FileClock.displayName = "FileClock";

export default FileClock;
